







































import {
  defineComponent, ref, reactive, computed, watch, Ref,
} from '@vue/composition-api';
import AccessoryCard from '~/components/marketplace/AccessoryCard.vue';
import OptionsMenu from '~/components/accessories/OptionsMenu.vue';
import { useToggleDrawer } from '~/composables/useToggleDrawer';
import { useFilterSort } from '~/composables/useFilterSort';
import MobileFilterMenu from './MobileFilterMenu.vue';
import MobileSortMenu from './MobileSortMenu.vue';
import MobileFilterButton from './MobileFilterButton.vue';
import MobileSortButton from './MobileSortButton.vue';
import DesktopSortView from './DesktopSortView.vue';
import DesktopFilterView from './DesktopFilterView.vue';

export default defineComponent({
  name: 'ProductFilterSort',
  components: {
    AccessoryCard,
    OptionsMenu,
    MobileFilterMenu,
    MobileSortMenu,
    MobileFilterButton,
    MobileSortButton,
    DesktopSortView,
    DesktopFilterView,
  },
  props: {
    accessoriesData: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const isFilter = ref(false);
    const isSort = ref(false);
    const activeTitle = computed(() => (isFilter.value ? 'Filter' : 'Sort'));
    const isMenuActive = computed(() => isFilter.value || isSort.value);
    function handleEvent(event: string) {
      if (event === 'close') {
        isFilter.value = false;
        isSort.value = false;
      }
    }

    const filters = reactive([
      { id: 'Bundles', selected: false },
      { id: 'Essentials', selected: false },
      { id: 'Setup', selected: false },
      { id: 'Training', selected: false },
      { id: 'Care', selected: false },
      { id: 'Apparel', selected: false },
    ]);
    const activeSort = ref('Best Sellers');
    const sorts = ref(['Best Sellers', 'Price Low to High', 'Price High to Low', 'From A-Z', 'From Z-A']);
    const filterList = ['Bundles', 'Essentials', 'Setup', 'Training', 'Care', 'Apparel'];

    const accessories = ref([...props.accessoriesData]) as Ref<any>;
    const totalAccessories = computed(() => accessories?.value?.length);

    watch([filters, activeSort], () => {
      const { itemsToDisplay } = useFilterSort({
        filterList, dataToFilter: props.accessoriesData, filters, activeSort,
      });

      accessories.value = itemsToDisplay;
    }, { deep: true });

    const menuOpen = ref(false);
    function updateSort(val: string) {
      activeSort.value = val;
      menuOpen.value = false;
    }

    const { openDrawer } = useToggleDrawer();

    function sortChange(active: string) {
      activeSort.value = active;
    }

    function toggleMenu() {
      menuOpen.value = !menuOpen.value;
    }

    return {
      sortChange,
      isFilter,
      isSort,
      activeTitle,
      isMenuActive,
      handleEvent,
      filters,
      sorts,
      accessories,
      activeSort,
      totalAccessories,
      menuOpen,
      updateSort,
      openDrawer,
      toggleMenu,
    };
  },
});
